export const APP_UI_STATE = "APP_UI_STATE";
